// global
import React, { Component, Suspense } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
// local
// components
import { Progress } from 'semantic-ui-react';
import MainMenu from './MainMenu';
import HomeHeader from './HomeHeader';
// import FixateMenuButton from '../commons/button/FixateMenuButton';
//assets
// actions
import { loginWithToken } from 'app/redux/actions/auth.action';
// storage
import { getToken } from 'app/storage/auth';
// stylesheets
import './Home.scss';
// routes config
import { getRoutes } from './routes';

class Home extends Component {
  state = {
    close: true,
    fixed: false
  };

  handleOpen = () => {
    if (this.state.close) {
      this.setState({ close: false });
    }
  };

  handleClose = () => {
    if (!this.state.close && !this.state.fixed) {
      this.setState({ close: true });
    }
  };

  componentDidMount() {
    const { isAuthenticated, account } = this.props.auth;
    if (isAuthenticated && !account) {
      this.props.dispatch(loginWithToken(getToken()));
    }
  }

  handleState = () => {
    if (this.state.fixed) {
      this.setState({
        fixed: false,
        close: false
      });
    } else {
      this.setState({
        fixed: true
      });
    }
  };

  render() {
    const { close } = this.state;
    const { fixed } = this.state;

    const { account, loading, loadingByToken } = this.props.auth;
    const fallback = <Progress size='tiny' percent={100} color='teal' indicating />;

    if (!account || loading || loadingByToken) {
      return fallback;
    }

    return (
      <div id='page-home'>
        <div onMouseEnter={this.handleOpen} onMouseLeave={this.handleClose}>
          <MainMenu account={account} handleState={this.handleState} fixed={fixed} close={close} />
        </div>

        <div id='home-body' className={fixed ? 'body-menu-open' : 'body-menu-close'}>
          <HomeHeader />
          <div id='home-content'>
            <Suspense fallback={fallback}>
              <Switch>
                {getRoutes(account).map(route => (
                  <Route
                    key={`route-${route.path}`}
                    exact={route.exact}
                    path={route.path}
                    component={route.component}
                  />
                ))}
              </Switch>
            </Suspense>
          </div>
        </div>
      </div>
    );
  }
}

Home.propTypes = {
  auth: PropTypes.object,
  dispatch: PropTypes.func
};

const mapStateToProps = state => ({
  auth: state.auth
});
export default connect(mapStateToProps)(Home);
